import React, { Component } from "react";
import Lightbox from "react-image-lightbox";

import Aux from "../../../../hoc/Aux/Aux";
import "./Koncepcje.css";

import imageSection2_1 from "../../../../img/architektura/Rysunek2.jpg";
import imageSection2_2 from "../../../../img/architektura/Rysunek3.jpg";
import imageSection2_3 from "../../../../img/architektura/Rysunek4.jpg";

const images = [imageSection2_1, imageSection2_2, imageSection2_3];

export default class Projekt extends Component {
  constructor(props) {
    super(props);

    this.state = {
      photoIndex: 0,
      isOpen: false,
      imagePadding: 100
    };
  }
  render() {
    const { photoIndex, isOpen } = this.state;

    return (
      <Aux>
        <div className="card-background row p-5">
          <div className="col-md lead mt-3">
            Gdy, nie wiadomo jak:
            <ul>
              <li>optymalnie ustawić meble</li>
              <li>zmienić układ ścian</li>
              <li>dopasować typowy projekt budowlany</li>
              <li>zdecydować się, bez spokojnej analizy rozwiązań</li>
              <li>ustalić zakres prac budowlanych</li>
            </ul>
          </div>
          <div className="col-md lead mt-3">
            Pomoże koncepcja:
            <ul>
              <li>3-4 różne wersje w formie prostych rzutów</li>
              <li>nowy układ ścian i rozstaw mebli</li>
              <li>poprawa istniejącej przestrzeni i funkcji</li>
              <li>położenie sanitariatów i wyposażenia łazienki</li>
              <li>wstęp do projektu</li>
              <li>minimalna dokumentacja</li>
            </ul>
          </div>
          <div className="row pt-4 d-flex justify-content-center">
            <div className="image-lightbox col-lg-3 m-2 p-1 border border-dark rounded">
              <img
                src={imageSection2_1}
                alt=""
                className="img-fluid"
                onClick={() => this.setState({ isOpen: true, photoIndex: 0 })}
              />
            </div>
            <div className="image-lightbox col-lg-3 m-2 p-1 border border-dark rounded">
              <img
                src={imageSection2_2}
                alt=""
                className="img-fluid"
                onClick={() => this.setState({ isOpen: true, photoIndex: 1 })}
              />
            </div>
            <div className="image-lightbox col-lg-3 m-2 p-1 border border-dark rounded">
              <img
                src={imageSection2_3}
                alt=""
                className="img-fluid"
                onClick={() => this.setState({ isOpen: true, photoIndex: 2 })}
              />
            </div>
          </div>
        </div>
        {isOpen && (
          <Lightbox
            mainSrc={images[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + images.length - 1) % images.length
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % images.length
              })
            }
          />
        )}
      </Aux>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Architecture/Services/Koncepcje/Koncepcje.js